import React from 'react';
import {LomavisPlatformIcon} from "../../../../atoms/icons/LomavisPlatformIcon";
import { PLATFORM_DISPLAY_NAME_KEYS_WITH_ALL } from '@/config/icons';
import { useTranslate } from '@tolgee/react';

interface LomavisTitle1Props {
    text: string;
    platform?: string;
}

/**
* Title component that takes displays the text as a title and optionally a platform icon. The platforms
 * can be found in `src/config/constants.ts` file. Example values are `facebook`, `google`, etc.
* */
export const LomavisTitle1: React.FC<LomavisTitle1Props> = ({ text, platform=null,  }) => {
  const {t} = useTranslate()

  return (
        <div className="d-flex text-gray-900 fw-bold fs-3 flex-row align-items-center justify-content-start my-0">
            {platform? <span><LomavisPlatformIcon platform={platform}></LomavisPlatformIcon>&nbsp;</span> : ""}{platform ? t(PLATFORM_DISPLAY_NAME_KEYS_WITH_ALL[platform]) : text}
        </div>
    );
};
